<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.alerts' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          
          <div class="card-body">
            <p class="card-text">{{ 'MENU.DASHBOARD.alerts_list' | translate }}</p>
          </div>
        </div>
  
        <div class="row d-flex justify-content-between">
          <div class="col-md-2 col-sm-12 mb-1 mb-md-0">
            <div class="form-group">
              <label for="itemsPerPage"  style="margin-right: 23px !important">{{ 'MENU.DASHBOARD.show' | translate }}</label>
              <div class="d-flex align-items-center">
                <select
                  id="itemsPerPage"
                  class="form-control form-control-sm "
                  [(ngModel)]="itemsPerPage"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span>{{ 'MENU.DASHBOARD.entries' | translate }}</span>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="searchInput" class="mr-2">{{ 'MENU.DASHBOARD.search' | translate }}</label>
              <input
                id="searchInput"
                type="search"
                placeholder="{{ 'MENU.DASHBOARD.search' | translate }}"
                class="form-control form-control-sm"
                (keyup)="filterUpdate($event)"
                (search)="filterUpdate($event)"
              />
            </div> 
          </div> -->
        </div>
  
        <ngx-datatable 
        [rows]="pages"
        [rowHeight]="58"
        class="bootstrap core-bootstrap bg-white"
        [limit]="itemsPerPage"
        [columnMode]="ColumnMode.force"
        [headerHeight]="40"
        [footerHeight]="50"
        [scrollbarH]="true"
                  [messages]="messages"

      >
   <!-- Title Arabic -->
<ngx-datatable-column
  name="{{ 'MENU.DASHBOARD.title_ar' | translate }}"
  prop="title_ar"
  [width]="300">
    <ng-template ngx-datatable-cell-template let-row="row">
   {{ truncateText(row.title_ar, 35) }}
  </ng-template>
</ngx-datatable-column>

<!-- Title English -->
<ngx-datatable-column
  name="{{ 'MENU.DASHBOARD.title_en' | translate }}"
  prop="title_en"
  [width]="300">
    <ng-template ngx-datatable-cell-template let-row="row">
   {{ truncateText(row.title_en, 35) }}
  </ng-template>
</ngx-datatable-column>

<ngx-datatable-column
  name="{{ 'MENU.DASHBOARD.body_ar' | translate }}"
  prop="body_ar"
  [width]="300">
  <ng-template ngx-datatable-cell-template let-row="row">
   {{ truncateText(row.body_ar, 35) }}
  </ng-template>
</ngx-datatable-column>


<!-- Body English -->
<ngx-datatable-column
  name="{{ 'MENU.DASHBOARD.body_en' | translate }}"
  prop="body_en"
  [width]="300">
  <ng-template ngx-datatable-cell-template let-row="row">
   {{ truncateText(row.body_en, 35) }}
  </ng-template>
</ngx-datatable-column>


      <!-- Type -->
      <ngx-datatable-column
        name="{{ 'MENU.DASHBOARD.notification_type' | translate }}"
        prop="target_type"
        [width]="130">
        <ng-template ngx-datatable-cell-template let-row="row">
          <span class="badge  text-dark">{{ row.target_type }}</span>
        </ng-template>
      </ngx-datatable-column>
       <ngx-datatable-column
        name="{{ 'MENU.DASHBOARD.user_name' | translate }}"
        prop="user.name"
        [width]="190">
        <ng-template ngx-datatable-cell-template let-row="row">
          <span class="badge  text-dark">{{ row.user?.name }}</span>
        </ng-template>
      </ngx-datatable-column>

      <!-- Date -->
      <ngx-datatable-column
        name="{{ 'MENU.DASHBOARD.date' | translate }}"
        prop="updated_at"
        [width]="220">
        <ng-template ngx-datatable-cell-template let-row="row">
          {{ row.updated_at | date: 'medium' }}
        </ng-template>
      </ngx-datatable-column>

      <!-- Status -->
      <!-- <ngx-datatable-column
        name="{{ 'MENU.DASHBOARD.status' | translate }}"
        prop="is_sent"
        [width]="120">
        <ng-template ngx-datatable-cell-template let-row="row">
          <span
            class="badge"
            [ngClass]="row.is_sent == '1' ? 'bg-success' : 'bg-warning text-dark'"
          >
            {{ row.is_sent == '1'
              ? ('MENU.DASHBOARD.sent' | translate)
              : ('MENU.DASHBOARD.pending' | translate) }}
          </span>
        </ng-template>
      </ngx-datatable-column> -->

      <!-- User ID -->
      <!-- <ngx-datatable-column
        name="{{ 'MENU.DASHBOARD.user_id' | translate }}"
        prop="user_id"
        [width]="120">
        <ng-template ngx-datatable-cell-template let-row="row">
          {{ row.user_id ? row.user_id : '-' }}
        </ng-template>
      </ngx-datatable-column> -->

      
  <!-- Actions -->
<ngx-datatable-column name="{{ 'MENU.DASHBOARD.investor_actions' | translate }}" prop="actions" [flexGrow]="1" [sortable]="false">
  <ng-template ngx-datatable-cell-template let-row="row">
    <div class="d-flex align-items-center">
      <div ngbDropdown container="body" class="btn-group">
        <button
          ngbDropdownToggle
          type="button"
          class="btn btn-sm btn-icon dropdown-toggle hide-arrow"
          [id]="'dropdownActions_' + row.id"
        >
          <i data-feather="more-vertical"></i>
        </button>

        <div
          ngbDropdownMenu
          class="dropdown-menu dropdown-menu-right"
          [attr.aria-labelledby]="'dropdownActions_' + row.id"
        >


           <!-- SHOW ALERT BUTTON -->
          <!-- <button
            class="dropdown-item w-100 text-primary"
            ngbDropdownItem
            (click)="showInfo(row)">
            <i data-feather="alert-circle" class="mr-50 mx-2"></i>
            {{ 'MENU.DASHBOARD.show_alert' | translate }}
          </button> -->


            <button 
  class="dropdown-item w-100  "
  ngbDropdownItem
  (click)="viewDetails(row.id)"
>
   <i data-feather="eye" class="mr-50 mx-2" ></i>

     {{ 'MENU.DASHBOARD.show_alert' | translate }}

</button>
                
          <button
            class="dropdown-item text-danger w-100"
            ngbDropdownItem
  (click)="confirmDelete(row.id)"
          >
            <i data-feather="trash" class="mr-50 mx-2"></i>
             {{ 'MENU.DASHBOARD.investor_delete' | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ngx-datatable-column>


      </ngx-datatable>
       
      </section>
    </div>
  </div>
  